import styled from 'styled-components'

export const Container = styled.div`
    .smartplayer-fake-bar {
        z-index: 999 !important;
    }
`
